module.exports = __webpack_public_path__ + "static/media/hemi_head_bd_it-webfont.ffd55354.eot";